import { useMatomo } from '@datapunt/matomo-tracker-react';
import React, { useEffect } from 'react';

import Header from '@components/common/Header/Header';

import useTranslation from '@hooks/useTranslation';

import CompanySavingCalculationSettings from './components/CompanySavingCalculationSettings/CompanySavingCalculationSettings';
import CostSavingCalculationSettings from './components/CostSavingCalculationSettings/CostSavingCalculationSettings';
import CostSavingTemplates from './components/CostSavingTemplates/CostSavingTemplates';
import MultiplicationFactorsLog from './components/MultiplicationFactorsLog/MultiplicationFactorsLog';
import style from './style.module.scss';

const lineBreak = { break: '</br>' };

const MultiplicationFactors = () => {
  const { trackPageView } = useMatomo();
  const { t } = useTranslation();

  useEffect(() => {
    trackPageView({});
  }, []);

  return (
    <div className={style.multiplicationFactors}>
      <Header
        title={t('Multiplication factors')}
        showLogo={true}
        extraInfo={
          <div
            className={style.messageBlock}
            dangerouslySetInnerHTML={{
              __html: t(
                'The multiplication factors you indicate here are multiplied by the downtime hours avoided in your action item completion reports. {break} OPTIONAL: When added with equipment/labor savings, this results in  your total cost avoided. This value is displayed in the Completion Report for Regular action items.',
                lineBreak,
              ),
            }}
          />
        }
      />

      <div className={style.multiplicationFactorsBody}>
        <CompanySavingCalculationSettings />
        <CostSavingCalculationSettings />
        <CostSavingTemplates />
        <MultiplicationFactorsLog />
      </div>
    </div>
  );
};

export default MultiplicationFactors;
